// extracted by mini-css-extract-plugin
export var circle = "_g-2";
export var icon = "_g-a";
export var iconHighlight = "_g-0";
export var lg = "_g-8";
export var md = "_g-7";
export var outline = "_g-4";
export var sm = "_g-6";
export var square = "_g-1";
export var xl = "_g-9";
export var xs = "_g-5";
export var xxs = "_g-3";